import React from 'react';
import { DividerProps } from 'common/types/types';

const Divider = ({ theme = 'horizontal', style }: DividerProps) => {
  const className = `border-warmGray ${theme === 'horizontal' ? 'border-b' : 'border-l'}`;
  return <div className={className} style={style} />;
};

export { Divider };
